<template>
  <v-layout fill-height column>
    <div class="progress-steps">
      <SleepProgress :current="1"/>
    </div>
    <div class="question-wrapper">
      <div class="question" v-html="ques[0]"></div>
    </div>
    <div class="answer">
      <ToggleBtn :total="strArr.length" :minWidth="300" :selectedVal="selectedVal" :str="strArr" :multiple="true"
                 :max="5" class="toggle-btn" @selectBtn="selectBtn" :cmplt="cmplt"/>
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import SleepProgress from "@/components/progress/SleepProgress"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
import ToggleBtn from '@/components/btns/ToggleBtn_sleepDiary'

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    disabledNext: true,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReply: [],
    strArr: [],
    selectedVal: [],
    selectArr: [],
  }),
  components: {
    SleepProgress,
    FooterBtnsNext,
    ToggleBtn
  },
  watch: {
    selectArr: {
      handler: function () {
        if (this.selectArr.length > 0) {
          this.disabledNext = false
        } else {
          this.disabledNext = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getUnitDetailUse()
  },
  mounted() {
  },
  methods: {
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl) => {

              // 질문 셋팅
              this.ques.push(quesEl.ques)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                this.replyObjArr.push(replyEl)
                // let obj = {'cd': k, 'cdNm': replyEl.reply}
                // this.strArr.push(obj)
                this.strArr.push(replyEl.reply)
              });
              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl) => {
                this.selectedVal.push(userReplyEl.reply)
                this.selectArr.push(userReplyEl.reply)
              });
            });

          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        this.selectArr.forEach((val, i) => {
          let n = this.strArr.indexOf(val)
          let replyObj = this.replyObjArr[n]

          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: 0,
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: val,
            // score: score,
            freeYn: this.free,
            unitType: "14",
          }
        })
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    selectBtn(val) {
      this.selectArr.splice(0, this.selectArr.length)
      this.selectArr = val
    }
  }
}
</script>
